// * Bootstrap libraries
import "./_bootstrap";
import "./_select-buttons";
import "./_paragraph-loading";
import "./_rotating-image-video";

// * Any other global site-wide JavaScript should be placed below.

(function (Drupal, once) {
  Drupal.behaviors.calculateScreenWidth = {
    attach: function (context, settings) {
      function updateWidth() {
        document.documentElement.style.setProperty('--full-width', document.body.clientWidth + 'px');
      }

      updateWidth();

      once('resize-listener', 'body').forEach(() => {
        window.addEventListener('resize', updateWidth);
      });
    }
  };

  Drupal.behaviors.searchApiSort = {
    attach: function (context, settings) {
      once('search-api-sort', '.product-sort-control').forEach((element) => {
        element.addEventListener('change', (e) => {
          const currentParams = new URLSearchParams(window.location.search)
          const option = e.target.querySelector(`[value="${e.target.value}"]`)
          currentParams.set('sort', option?.getAttribute('data-sort-field'))
          currentParams.set('order', option?.getAttribute('data-sort-order'))
          window.location.search = currentParams.toString()
        })
      })
    }
  }

  Drupal.behaviors.menuExpand = {
    attach: function (context, settings) {
      once('no-link-items', '.ultimenu__link:not([href])').forEach((item) => {
        const flyout = item.parentNode?.querySelector('.ultimenu__flyout')
        if (flyout) {
          item.addEventListener('click', () => {
            // Ignore for desktops.
            if (window.innerWidth < 991) {
              item.classList.add('is-ultimenu-active')
              flyout.classList.add('is-flyout-expanded')
            }
          })
        }
      })
    }
  }

  Drupal.behaviors.viewFiltersToggle = {
    attach: function (context) {
      once('viewFiltersToggle', '.view-table__filters_button', context).forEach(function (button) {
        const wrapper = button.closest('.view-table__filters_wrapper');
        if (!wrapper) return;

        const form = wrapper.querySelector('.view-table__filters');
        if (!form) return;

        function initToggleBehavior() {
          const isMobile = window.matchMedia('(max-width: 992px)').matches;

          if (isMobile) {
            button.disabled = false;
            button.setAttribute('aria-expanded', 'false');
            wrapper.classList.remove('is-open');
            form.style.maxHeight = '0';
            form.style.overflow = 'hidden';
            form.style.transition = 'max-height 0.4s ease';

            button.addEventListener('click', toggleFilters);
          } else {
            // Десктоп — показываем форму всегда, убираем JS-анимацию
            form.style.maxHeight = 'none';
            form.style.overflow = 'visible';
            wrapper.classList.add('is-open');
            button.removeEventListener('click', toggleFilters);
          }
        }

        function toggleFilters() {
          const isOpen = wrapper.classList.contains('is-open');

          if (isOpen) {
            form.style.maxHeight = form.scrollHeight + 'px';
            requestAnimationFrame(() => {
              form.style.maxHeight = '0';
            });
            wrapper.classList.remove('is-open');
            button.classList.remove('is-active');
            button.setAttribute('aria-expanded', 'false');
          } else {
            form.style.maxHeight = form.scrollHeight + 'px';
            wrapper.classList.add('is-open');
            button.classList.add('is-active');
            button.setAttribute('aria-expanded', 'true');

            form.addEventListener('transitionend', function resetHeight() {
              if (wrapper.classList.contains('is-open')) {
                form.style.maxHeight = 'none';
              }
              form.removeEventListener('transitionend', resetHeight);
            });
          }
        }

        initToggleBehavior();

        window.addEventListener('resize', Drupal.debounce(initToggleBehavior, 200));
      });
    }
  };

  Drupal.behaviors.ckeditor5BsModalFix = {
    attach: function (context, settings) {
      const modal = context.querySelector('.modal.show')

      if (modal) {
        setTimeout(function () {
          const ckBody = document.querySelector('.ck-body-wrapper')

          modal.append(ckBody)
        }, 100)
      }
    }
  }
})(Drupal, once);

(function (Drupal, once, Splide) {
  Drupal.behaviors.splideSlider = {
    attach: function (context, settings) {
      once('splide-slider', '.splide', context).forEach(function (slider) {

        const selector = `#${slider.id}`,
          perPage = slider.getAttribute('data-slides-per-page') || 3,
          arrows = slider.getAttribute('data-arrows-enabled') === 'true',
          dots = slider.getAttribute('data-dots-enabled') === 'true',
          autoRotate = slider.getAttribute('data-auto-rotate-enabled') === 'true',
          itemGap = slider.getAttribute('data-item-gap')

        let splide = new Splide(selector, {
          type: autoRotate ? 'loop' : 'slide',
          perPage: perPage,
          perMove: 1,
          arrows: arrows,
          pagination: dots,
          autoplay: autoRotate,
          gap: itemGap,
          breakpoints: {
            1000: {
              perPage: Math.max(1, Math.min(2, perPage - 1))
            },
            640: {
              perPage: 1
            }
          }
        })

        splide.mount()
      })
    }
  }
})(Drupal, once, Splide);
